import React from 'react'
import MidItem from './MidItem'

export default function Mid({articles}) {

  return (
    <div className='mid-cont'>

        {articles.map((e, index) => 

        <MidItem key={index} {...e} />
          
        )}
    </div>
  )
}
